<ion-content>
  <div style="display: flex; flex-direction: column; height: 100vh; width: 100vw;">

  
    <div class="ds-accounts-body">
      <div class="ds-accounts-body-title">
        {{ 'SELECT_YOUR_PLAN' | translate }}
      </div>

      <div class="ds-accounts-body-plans">
        <!-- Use *ngFor to loop through pricingCards array -->
        <div class="ds-card-pricing" *ngFor="let card of pricingCards">
          <div class="ds-card-pricing-title">
            {{ card.showingTitle }}
          </div>
          <div class="ds-card-pricing-price">
            <span class="price-symbol">€</span>
            <span class="price-amount">{{ card.price }}</span>
            <span class="price-period">/ {{ 'MONTHLY' | translate }}</span> <!-- Assuming all are monthly plans -->
          </div>

          <hr>

          <div class="ds-card-pricing-features">
            <!-- Loop through each card's features -->
            <div class="ds-card-pricing-features-item" *ngFor="let feature of card.features">
              <ion-icon name="checkmark-circle"></ion-icon>
              <span>{{ feature?.text }}</span>
            </div>
          </div>

          <div class="ds-card-pricing-button" *ngIf="card?.title !== 'free' && card?.id !== userData?.totalumInstances?.[0]?.plan">
            <button class="ds-button-primary" (click)="selectPlan(card?.title)">
              {{"SELECT_PLAN" | translate }}
              <ion-icon name="arrow-forward"></ion-icon>
            </button>
          </div>

          <div class="ds-card-pricing-button" *ngIf="card?.id === userData?.totalumInstances?.[0]?.plan">
            <button class="ds-button-tertiary">
              <ion-icon name="checkmark"></ion-icon>
              {{"CURRENT_PLAN" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</ion-content>

